import { createApp } from 'vue';
import App from './App.vue';
import router from './router';

// Vuetify
import 'vuetify/styles';
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import '@mdi/font/css/materialdesignicons.css';
import './styles/styles.scss';
import './styles/utility.scss';
import axiosService from './modules/global/services/axios';
import { createPinia } from 'pinia';
import snackbar from './modules/global/plugins/snackbar';
import getOssClient from './modules/global/services/oss';

import moment from 'moment';
import 'moment/locale/id';

const vuetify = createVuetify({
    components,
    directives,
});

const app = createApp(App);

app.config.globalProperties.$alioss = getOssClient;

app.config.globalProperties.$moment = moment;
app.use(axiosService);
window.$http = app.config.globalProperties.$axios;

app.use(vuetify);
app.use(router);
app.use(createPinia());
app.use(snackbar);

app.mount('#app');
